import '../css/ImageModal.css';

const ImageModal = ({ image, closeImage }) => {
    // 支援單張或多張顯示
    const { src, gallery } = image;
    const images = gallery ?? [src]; // 若有 gallery 用 gallery，否則用單張

    return (
        <>
            <div
                className="image-modal"
                role="dialog"
                aria-modal="true"
                onClick={closeImage}
            >
                <div
                    className="image-modal-inner"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button className="image-close" onClick={closeImage}>
                        ✕
                    </button>

                    {/* 圖片清單 */}
                    <div className={`image-gallery ${images.length > 1 ? 'multi' : ''}`}>
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                alt={`preview-${index}`}
                                className="image-full"
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export { ImageModal };
